import {VGNav} from "vgnav";
import VGRollup from "vgrollup/src/VGRollup/js/VGRollup";
import {VGLawCookie} from "vglawcookie";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.clone();
		VG.scrollToMap();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));
		VG.fixedHeader($(window));

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
		VG.fixedHeader($self);
	},

	onResize: ($self) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization", "color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	clone: () => {
		let $obj_services_clone = $('.services-page .services-navigation--clone');
		if (window.innerWidth < 992 && $obj_services_clone) {
			if ($obj_services_clone.length) {
				$('.services-page .services-navigation--clone .list-navigation a').attr('data-dismiss', 'vg-sidebar');
				$obj_services_clone.clone(true).detach();
				$('.services-sidebar--clone-navigation').append($obj_services_clone)
			}
		}

		let $obj_portfolios_clone = $('.portfolios-page .portfolios-navigation--clone');
		if (window.innerWidth < 992 && $obj_portfolios_clone) {
			if ($obj_portfolios_clone.length) {
				$('.portfolios-page .portfolios-navigation--clone .list-navigation a').attr('data-dismiss', 'vg-sidebar');
				$obj_portfolios_clone.clone(true).detach();
				$('.portfolios-sidebar--clone-navigation').append($obj_portfolios_clone)
			}
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableRollup();
			VG.plugins.enableSumoSelect();
			VG.plugins.enableLawCookie();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'lg',
				toggle: '<i class="fa fa-chevron-down"></i>'
			});
		},

		enableAOS: function () {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableNiceSelect: function () {
			$('.nice-select').niceSelect();
		},

		enableLawCookie: function () {
			new VGLawCookie();
		},

		enableRollup: () => {
			let $rollups = document.querySelectorAll('[data-rollup-content]');
			for (let i = 1; i <= $rollups.length; i++) {
				let target = $rollups[i - 1].getAttribute('id');

				new VGRollup(target);
			}
		},

		enableSumoSelect: function () {
			let el = $('[data-toggle="sumoselect"]');
			if (!el.length) return;

			// TODO на русском
			let defaults = {
				placeholder: 'Выбрать',
				csvDispCount: 3,
				captionFormat: '{0} Выбрано',
				captionFormatAllSelected: '{0} выбраны все!',
				floatWidth: 400,
				forceCustomRendering: false,
				nativeOnDevice: ['Android', 'BlackBerry', 'iPhone', 'iPad', 'iPod', 'Opera Mini', 'IEMobile', 'Silk'],
				outputAsCSV: false,
				csvSepChar: ',',
				okCancelInMulti: false,
				isClickAwayOk: false,
				triggerChangeCombined: true,
				selectAll: false,
				search: true,
				searchText: 'Найти...',
				searchFn: function (haystack, needle, el) {
					return haystack.toLowerCase().indexOf(needle.toLowerCase()) < 0;
				},
				noMatch: 'Ничего не найдено "{0}"',
				prefix: '',
				locale: ['OK', 'Отмена', 'Выбрать все'],
				up: false,
				showTitle: true,
				max: null,
				renderLi: (li, originalOption) => li,
				clearAll: false,
				closeAfterClearAll: false
			};

			el.each(function () {
				let $this = $(this),
					options = $this.data('plugin-options');

				if (options === undefined) options = {};
				options = $.extend({}, defaults, options);
				options.search = !this.getAttribute('data-search') ? true : '';

				$this.SumoSelect(options);
			});
		},
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);
			let $sidebar_services = $('#' + this.services);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="' + this.btn + '"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.header-wrapper'),
			scroll = $self.scrollTop(),
			$body = $('body');

		if (scroll > 0) {
			$body.addClass('header--is-fixed');
			$sticky.addClass('fixed');
		} else {
			$sticky.removeClass('fixed');
			$body.removeClass('header--is-fixed');
		}
	},

	scrollToMap: () => {
		$(".page-contacts a[href=\"#yaMapHome\"]").click(function() {
			$([document.documentElement, document.body]).animate({
				scrollTop: $(".contacts-area-map").offset().top - ($('.header .header-wrapper').height() + 50),
			}, 0);

			return false
		});
	}
};


export default VGListener;
